import component from './PhHandshake.vue_vue&type=script&lang.js';
export { default } from './PhHandshake.vue_vue&type=script&lang.js';
import { render } from './PhHandshake.vue_vue&type=template&id=c4876edc&lang.js';

component.render = render;
